/* SCC decks: lets players pick any Shuffle Club deck to play with (Game Night and Beat the Dealer).
   The deck list comes from snippets/scc-deck-list.liquid (#scc-decks). A deck with print files in Assets (Pastel)
   plays with its real card faces; every other deck plays with cards built from its own product photo, and its
   colour is read from that photo. window.SCCDecks: get, list, saved, save, tint, face, back, picker. */
(function () {
  'use strict';
  if (window.SCCDecks) return;
  var SUIT = { s: '♠', h: '♥', d: '♦', c: '♣' };
  var list = null, byH = {}, tints = {};

  function load() {
    if (list) return list;
    list = [];
    var el = document.getElementById('scc-decks');
    if (el) { try { list = JSON.parse(el.textContent) || []; } catch (e) { list = []; } }
    list.forEach(function (d) { byH[d.h] = d; });
    return list;
  }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- colour from the deck photo ---------- */
  function hex(c) { return '#' + c.map(function (v) { return ('0' + Math.max(0, Math.min(255, Math.round(v))).toString(16)).slice(-2); }).join(''); }
  function hsl(c) {
    var r = c[0] / 255, g = c[1] / 255, b = c[2] / 255, mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, h = 0, s = 0;
    if (mx !== mn) {
      var d = mx - mn; s = l > 0.5 ? d / (2 - mx - mn) : d / (mx + mn);
      h = mx === r ? (g - b) / d + (g < b ? 6 : 0) : mx === g ? (b - r) / d + 2 : (r - g) / d + 4; h *= 60;
    }
    return [h, s, l];
  }
  function rgbHex(h, s, l) {
    var a = s * Math.min(l, 1 - l);
    function f(n) { var k = (n + h / 30) % 12; return 255 * (l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1))); }
    return hex([f(0), f(8), f(4)]);
  }
  function mix(a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t]; }
  function sample(src) {
    return new Promise(function (res) {
      if (!src) { res(null); return; }
      var img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var c = document.createElement('canvas'), n = 28; c.width = n; c.height = n;
          var x = c.getContext('2d'); x.drawImage(img, 0, 0, n, n);
          var d = x.getImageData(0, 0, n, n).data, buckets = {};
          for (var i = 0; i < d.length; i += 4) {
            var r = d[i], g = d[i + 1], b = d[i + 2], a = d[i + 3];
            var mx = Math.max(r, g, b), mn = Math.min(r, g, b), sat = mx ? (mx - mn) / mx : 0;
            if (a < 200 || mx > 238 && sat < 0.12 || mx < 28) continue; /* skip white backdrop and black ink */
            var key = (r >> 5) + ',' + (g >> 5) + ',' + (b >> 5);
            var bk = buckets[key] || (buckets[key] = { n: 0, r: 0, g: 0, b: 0, s: 0 });
            bk.n++; bk.r += r; bk.g += g; bk.b += b; bk.s += sat;
          }
          var best = null, score = -1;
          Object.keys(buckets).forEach(function (k) { var bk = buckets[k]; var sc = bk.n * (0.35 + bk.s / bk.n); if (sc > score) { score = sc; best = bk; } });
          res(best ? [best.r / best.n, best.g / best.n, best.b / best.n] : null);
        } catch (e) { res(null); }
      };
      img.onerror = function () { res(null); };
      img.src = src;
    });
  }
  /* { accent, table, felt, soft } for a deck; cached for the session */
  function tint(d) {
    if (!d) return Promise.resolve(null);
    if (tints[d.h]) return Promise.resolve(tints[d.h]);
    try { var c = sessionStorage.getItem('scc-tint3-' + d.h); if (c) { tints[d.h] = JSON.parse(c); return Promise.resolve(tints[d.h]); } } catch (e) {}
    return sample(d.s).then(function (rgb) {
      /* keep the hue of the deck, but hold saturation and lightness in a range that reads as felt:
         pale or grey photos would otherwise give a washed-out table and white card backs */
      var h = hsl(rgb || [76, 23, 0]), grey = h[1] < 0.12;
      var hue = grey ? 24 : h[0], sat = grey ? 0.45 : Math.max(0.38, Math.min(0.75, h[1]));
      var t = { accent: rgbHex(hue, sat, Math.max(0.3, Math.min(0.46, h[2]))), table: rgbHex(hue, sat * 0.85, 0.2), felt: rgbHex(hue, sat * 0.8, 0.12), soft: rgbHex(hue, Math.min(0.6, sat), 0.94) };
      tints[d.h] = t;
      try { sessionStorage.setItem('scc-tint3-' + d.h, JSON.stringify(t)); } catch (e) {}
      return t;
    });
  }

  /* ---------- cards ----------
     rank: 'a','2'..'10','j','q','k'   suit: 's','h','d','c' */
  function artUrl(d, file) { return d.art.base + d.art.prefix + '-' + file + '.' + (d.art.ext || 'svg'); }
  /* real card art: Pastel's SVG print files, or a card sheet in Files (<prefix>-cards.webp: 14 x 4 cells,
     columns a,2..10,j,q,k then back/joker; rows s,h,d,c) */
  var COLS = ['a', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'j', 'q', 'k'], ROWS = { s: 0, h: 1, d: 2, c: 3 };
  function native(d) { return !!(d && d.art && (d.art.ext || 'svg') === 'svg'); }
  function hasCards(d) { return !!(d && d.art && (d.art.sprite || native(d))); }
  function cell(d, col, row) {
    return '<span class="sccd-sprite" style="background-image:url(' + esc(d.art.base + d.art.prefix + '-cards.webp') + ');background-position:' + (col / 13 * 100) + '% ' + (row / 3 * 100) + '%"></span>';
  }
  /* the tuck box sheet (<prefix>-box.webp, 1170 x 837): front, back, side in a row, the lid under them */
  var BOX = { front: [0, 0, 500, 667], back: [500, 0, 500, 667], side: [1000, 0, 170, 667], lid: [0, 667, 500, 170] }, BW = 1170, BH = 837;
  function panel(d, k) {
    var p = BOX[k];
    return '<span class="sccd-panel" style="background-image:url(' + esc(d.art.base + d.art.prefix + '-box.webp') + ');background-size:' + (BW / p[2] * 100) + '% ' + (BH / p[3] * 100) + '%;background-position:' + (p[0] ? p[0] / (BW - p[2]) * 100 : 0) + '% ' + (p[1] ? p[1] / (BH - p[3]) * 100 : 0) + '%"></span>';
  }

  /* ---------- the real tuck box: the flap flips up, the deck rises out, three cards fan ----------
     Needs the box panels (art.box): <prefix>-boxfront/back/side/lid. Returns false when the deck has none. */
  function unbox(host, d, opts) {
    if (!host) return false;
    if (!d || !d.art || !d.art.box) { host.hidden = true; host.innerHTML = ''; return false; }
    opts = opts || {};
    var fan = (opts.fan || ['as', 'kh', 'qd']).map(function (c, i) {
      return '<span class="sccu__card" style="--i:' + i + '">' + face(d, c.slice(0, -1), c.slice(-1)) + '</span>';
    }).join('');
    var stack = ''; for (var i = 0; i < 4; i++) stack += '<span class="sccu__back" style="--k:' + i + '">' + back(d) + '</span>';
    host.hidden = false;
    host.classList.add('sccu');
    host.classList.remove('is-open', 'is-out', 'is-fan');
    host.innerHTML =
      '<div class="sccu__scene" aria-hidden="true">' +
        '<span class="sccu__deck">' + stack + '</span>' +
        '<span class="sccu__box">' + panel(d, 'front') + '</span>' +
        '<span class="sccu__lid">' + panel(d, 'lid') + '</span>' +
        '<span class="sccu__fan">' + fan + '</span>' +
      '</div>';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    clearTimeout(host.__t1); clearTimeout(host.__t2); clearTimeout(host.__t3);
    if (reduce) { host.classList.add('is-open', 'is-out', 'is-fan'); return true; }
    var go = function () {
      host.__t1 = setTimeout(function () { host.classList.add('is-open'); }, 300);
      host.__t2 = setTimeout(function () { host.classList.add('is-out'); }, 850);
      host.__t3 = setTimeout(function () { host.classList.add('is-fan'); }, 1650);
    };
    /* play when it scrolls into view */
    if ('IntersectionObserver' in window && !opts.now) {
      if (host.__io) host.__io.disconnect();
      host.__io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { host.__io.disconnect(); go(); } }, { threshold: 0.45 });
      host.__io.observe(host);
    } else go();
    return true;
  }
  function face(d, rank, suit) {
    rank = String(rank).toLowerCase(); suit = String(suit).toLowerCase();
    if (hasCards(d)) return d.art.sprite ? cell(d, COLS.indexOf(rank), ROWS[suit]) : '<img class="sccd-img" src="' + esc(artUrl(d, 'c' + rank + suit)) + '" alt="" draggable="false">';
    var R = rank.toUpperCase(), S = SUIT[suit] || '', red = suit === 'h' || suit === 'd';
    var court = rank === 'j' || rank === 'q' || rank === 'k';
    var mid = court
      ? '<span class="sccd-face__court"><img src="' + esc(d ? d.i : '') + '" alt="" loading="lazy" decoding="async" draggable="false"><b>' + R + '</b></span>'
      : '<span class="sccd-face__pip' + (rank === 'a' ? ' is-ace' : '') + '">' + S + '</span>';
    return '<span class="sccd-face' + (red ? ' is-red' : '') + '"><span class="sccd-face__idx"><b>' + R + '</b><i>' + S + '</i></span>' + mid +
      '<span class="sccd-face__idx sccd-face__idx--b"><b>' + R + '</b><i>' + S + '</i></span></span>';
  }
  function back(d) {
    if (hasCards(d)) return d.art.sprite ? cell(d, 13, 0) : '<img class="sccd-img" src="' + esc(artUrl(d, 'cback')) + '" alt="" draggable="false">';
    return '<span class="sccd-back"><span class="sccd-back__medal"><img src="' + esc(d ? d.i : '') + '" alt="" loading="lazy" decoding="async" draggable="false"></span></span>';
  }

  /* ---------- the picker ----------
     opts: { selected: handle, first: handle (listed first), label, onPick(deck) } */
  function picker(host, opts) {
    load();
    if (!host || !list.length) return null;
    opts = opts || {};
    var decks = list.slice();
    if (opts.first && byH[opts.first]) { decks = [byH[opts.first]].concat(decks.filter(function (d) { return d.h !== opts.first; })); }
    var sel = opts.selected && byH[opts.selected] ? opts.selected : null; /* a deck outside the list (a multi-pack page) leaves nothing ticked */
    host.classList.add('sccd-pick');
    host.innerHTML =
      '<div class="sccd-pick__top"><span class="sccd-pick__label">' + esc(opts.label || 'Pick your deck') + '</span><span class="sccd-pick__now" data-sccd-now></span>' +
      '<span class="sccd-pick__arrows"><button type="button" class="sccd-pick__arrow" data-sccd-step="-1" aria-label="Earlier decks">&lsaquo;</button><button type="button" class="sccd-pick__arrow" data-sccd-step="1" aria-label="More decks">&rsaquo;</button></span></div>' +
      '<div class="sccd-pick__row" role="radiogroup" aria-label="' + esc(opts.label || 'Pick your deck') + '">' +
      decks.map(function (d) {
        return '<button type="button" class="sccd-chip" role="radio" aria-checked="false" data-h="' + esc(d.h) + '" title="' + esc(d.n) + '">' +
          '<span class="sccd-chip__img"><img src="' + esc(d.t) + '" alt="" loading="lazy" decoding="async" width="56" height="56"></span>' +
          '<span class="sccd-chip__name">' + esc(d.n) + '</span>' + (hasCards(d) ? '<span class="sccd-chip__tag">Full art</span>' : '') + '</button>';
      }).join('') + '</div>';
    var row = host.querySelector('.sccd-pick__row'), now = host.querySelector('[data-sccd-now]');
    function mark(h, scroll) {
      sel = h;
      [].forEach.call(row.children, function (b) {
        var on = b.getAttribute('data-h') === h;
        b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
        if (on && scroll) { var l = b.offsetLeft - (row.clientWidth - b.offsetWidth) / 2; row.scrollTo({ left: Math.max(0, l), behavior: scroll === 'smooth' ? 'smooth' : 'auto' }); }
      });
      if (now && byH[h]) now.textContent = byH[h].n;
    }
    row.addEventListener('click', function (e) {
      var b = e.target.closest('.sccd-chip'); if (!b) return;
      var h = b.getAttribute('data-h'); if (h === sel) return;
      mark(h, 'smooth');
      if (opts.onPick) opts.onPick(byH[h]);
    });
    row.addEventListener('keydown', function (e) {
      if (['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(e.key) < 0) return;
      e.preventDefault();
      var kids = [].slice.call(row.children), i = kids.findIndex(function (b) { return b.getAttribute('data-h') === sel; });
      var n = kids[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + kids.length) % kids.length];
      n.focus(); n.click();
    });
    [].forEach.call(host.querySelectorAll('[data-sccd-step]'), function (b) {
      b.addEventListener('click', function () { row.scrollBy({ left: parseInt(b.getAttribute('data-sccd-step'), 10) * row.clientWidth * 0.8, behavior: 'smooth' }); });
    });
    mark(sel, true);
    return { select: function (h) { if (byH[h]) mark(h, 'smooth'); }, get: function () { return byH[sel]; } };
  }

  window.SCCDecks = {
    list: function () { return load(); },
    get: function (h) { load(); return byH[h] || null; },
    saved: function () { load(); var h = store('scc-deck'); return h && byH[h] ? h : null; },
    save: function (h) { store('scc-deck', h); },
    tint: tint, face: face, back: back, picker: picker, unbox: unbox, native: native, hasCards: hasCards,
    sheet: function (d) { return hasCards(d) && d.art.sprite ? d.art.base + d.art.prefix + '-cards.webp' : ''; }
  };
  try { document.dispatchEvent(new CustomEvent('scc:decks-ready')); } catch (e) {}
})();